import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import LeftSideMenuBar from './LeftSideMenuBar';
import React, { useEffect, useState } from 'react';
import { AuthenticatedTemplate, useMsal, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import axios from 'axios';

export default function Landing() {
    const { login } = useMsalAuthentication(InteractionType.Redirect);

    const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;
    const USER_PROFILE = process.env.REACT_APP_GET_AUTH_USER_ROLE_URL;
    const { accounts } = useMsal();
    const [email, setEmail] = useState();
    const [unauthorized, setUnauthorized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (accounts[0]) {
            setEmail(accounts[0].username);
        }
    }, [accounts]);
    useEffect(() => {
        if (email) {
            const fetchAuthorization = async () => {
                const userData = {
                    email: email
                }

                setLoading(true);
                setError(null);
                try {
                    const response = await axios.post(`${ADMIN_BASE_URL}${USER_PROFILE}`, userData);
                    if (response.data[0]) {
                        sessionStorage.setItem('user', JSON.stringify(response.data[0]));
                        setUnauthorized(false);
                    }
                    else
                        setUnauthorized(true);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            const storedUser = sessionStorage.getItem('user');
            console.log(storedUser);
            if (!storedUser) {
                fetchAuthorization();
            }
        }
    }, [email]);
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    if (unauthorized) return <center>You are not authorized to use this system, Please reach out PHMC! </center>;
    return (
        <React.Fragment>
            <div className='phmc-main'>
                <Header />
                <AuthenticatedTemplate>
                    <Container fluid>
                        <Row className="row">
                            <Col md={2} className="left-nav" >
                                <LeftSideMenuBar />
                            </Col>
                            <Col md={10}>
                                <div className="content">
                                    <Outlet />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </AuthenticatedTemplate>

                {/* <Container fluid>
                    <Row className="row">
                        <Col md={2} className="left-nav" >
                            <LeftSideMenuBar />
                        </Col>
                        <Col md={10}>
                            <div className="content">
                                <Outlet />
                            </div>
                        </Col>
                    </Row>
                </Container> */}
                <Footer />
            </div >
        </React.Fragment>
    );
}

